import React, { useContext, useEffect, useState } from "react";
import Header from "../components/layout/Header";
import SideBar from "../components/layout/SideBar";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import Service from "../services";
import { BankUserContext } from "../bankUserContext";
import { IOrgProductModel } from "../models/SharedModel";
import { toast } from "react-toastify";
import { TrackersEnum } from "../models/TrackerModel";
import { RoutesEnum } from "../utils/RoutesUtil";
import { catchErrorGeneric } from "../utils/GeneralUtils";
import ClientSideBar from "../components/layout/SideNav/ClientSidebar";

interface LayoutPage {
  LogoData: any;
  MenuItemsData: any;
}
const LayoutPage: React.FC<LayoutPage> = ({ LogoData, MenuItemsData }) => {
  // const LayoutPage: React.FC = (LogoData) => {
  const service = new Service();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const { selectedProduct, setSelectedProduct } = useContext(BankUserContext);

  const [logosList, setLogosList] = useState<LayoutPage[]>([]);
  const [menuItemsData, setMenuItemsData] = useState<LayoutPage[]>([]);
  const [showProductsHeader, setShowProductsHeader] = useState<boolean>(false);
  const [extraPadding, setExtraPadding] = useState(false);
  const [complianceView, setComplianceView] = useState(false);
  const [summaryReportView, setSummaryReportView] = useState(false);
  
  

 useEffect(()=>{
  const pathValues = location?.pathname?.split("/");
  const complianceView = (pathValues?.includes(RoutesEnum.COMPLIANCE_VIEW) || pathValues?.includes(RoutesEnum.CLIENT_QUESTIONARIE));
  setSummaryReportView(location?.pathname?.indexOf("complianceView/getSummaryReport") >-1);
  setComplianceView(complianceView);

 },[location])

  // Set the logos Data
  useEffect(() => {
    setLogosList(LogoData);
    setMenuItemsData(MenuItemsData);
  }, [LogoData, MenuItemsData]);

  // orgProductsList
  useEffect(() => {
    const orgProductsListSession = sessionStorage.getItem("orgProductsList");
    if (params?.orgProductId && orgProductsListSession && !selectedProduct) {
      const list: IOrgProductModel[] = JSON.parse(orgProductsListSession);
      const value = list?.find(
        (each) => each?.orgLevelProductId === params?.orgProductId
      );
      if (value) {
        setSelectedProduct(value); // Todo: replace with below
        sessionStorage.setItem("selectedProduct", JSON.stringify(value));
      }
    }
  }, [params?.orgProductId]);

  useEffect(() => {
    if (location?.pathname?.includes(RoutesEnum.MESSAGE_CENTER) || complianceView) {
      setExtraPadding(false);
    }
  }, [location?.pathname]);

  const productRedirection = (
    value: IOrgProductModel,
    trackerType?: TrackersEnum | string
  ) => {
    if (value?.orgLevelProductId) {
      setSelectedProduct(value);
      sessionStorage.setItem("selectedProduct", JSON.stringify(value));
      let url = "";
      if (trackerType) {
        url = `${RoutesEnum.TRACKER}/${trackerType}/${value.orgLevelProductId}`;
      } else
        url = `${RoutesEnum.TRACKER}/${TrackersEnum.APPLICATIONS}/${value.orgLevelProductId}`;
      navigate(url);
    } else catchErrorGeneric("Something went wrong");
    // toast.error("Something went wrong");
  };

  useEffect(() => {
    const pathValues = location?.pathname?.split("/");
    if (
      pathValues?.includes(RoutesEnum.TRACKER) &&
      ( pathValues?.includes(TrackersEnum.APPLICATIONS) ||
        pathValues?.includes(TrackersEnum.OPPORTUNITIES) ||
        pathValues?.includes(TrackersEnum.UNDERWRITING)
      )
    ) {
      setShowProductsHeader(true);
    } else setShowProductsHeader(false);
  }, [location?.pathname]);

  return (
    <div className={`home ${showProductsHeader ? "selected" : ""}`}>
      {!complianceView &&!summaryReportView &&<Header
        LogoData={logosList || []}
        productRedirection={productRedirection}
        showProductsHeader={showProductsHeader}
      />}
      <div
        className={`layout-inner d-flex ${complianceView ? "compliance-layout" : "content-global-wrapper"} ${
          extraPadding ? "pt-3 px-2" : ""
        }`
      }
      >
        
        {!complianceView && !summaryReportView && <SideBar
          LogoData={logosList || []}
          MenuItemsData={menuItemsData || []}
          productRedirection={productRedirection}
          showProductsHeader={showProductsHeader}
        />}
        {complianceView && !summaryReportView &&<ClientSideBar />}
        <Outlet />
      </div>
    </div>
  );
};



export default LayoutPage;
